import script from "./classical-layout-with-sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./classical-layout-with-sidebar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__